import _slicedToArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useSandpack } from "../../hooks/useSandpack";
import { BackwardIcon, ForwardIcon, RefreshIcon } from "../../icons";
import { splitUrl } from "./utils";
export var Navigator = function Navigator(_ref) {
  var clientId = _ref.clientId,
      onURLChange = _ref.onURLChange;

  var _a;

  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      baseUrl = _React$useState2[0],
      setBaseUrl = _React$useState2[1];

  var _useSandpack = useSandpack(),
      sandpack = _useSandpack.sandpack,
      dispatch = _useSandpack.dispatch,
      listen = _useSandpack.listen;

  var _React$useState3 = React.useState((_a = sandpack.startRoute) !== null && _a !== void 0 ? _a : "/"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      relativeUrl = _React$useState4[0],
      setRelativeUrl = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      backEnabled = _React$useState6[0],
      setBackEnabled = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      forwardEnabled = _React$useState8[0],
      setForwardEnabled = _React$useState8[1];

  var c = useClasser("sp");
  React.useEffect(function () {
    var unsub = listen(function (message) {
      if (message.type === "urlchange") {
        var url = message.url,
            back = message.back,
            forward = message.forward;

        var _splitUrl = splitUrl(url),
            _splitUrl2 = _slicedToArray(_splitUrl, 2),
            newBaseUrl = _splitUrl2[0],
            newRelativeUrl = _splitUrl2[1];

        setBaseUrl(newBaseUrl);
        setRelativeUrl(newRelativeUrl);
        setBackEnabled(back);
        setForwardEnabled(forward);
      }
    }, clientId);
    return function () {
      return unsub();
    };
  }, []);

  var handleInputChange = function handleInputChange(e) {
    var path = e.target.value.startsWith("/") ? e.target.value : "/".concat(e.target.value);
    setRelativeUrl(path);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.code === "Enter") {
      //  Enter
      e.preventDefault();
      e.stopPropagation();

      if (typeof onURLChange === "function") {
        onURLChange(baseUrl + e.currentTarget.value);
      }
    }
  };

  var handleRefresh = function handleRefresh() {
    dispatch({
      type: "refresh"
    });
  };

  var handleBack = function handleBack() {
    dispatch({
      type: "urlback"
    });
  };

  var handleForward = function handleForward() {
    dispatch({
      type: "urlforward"
    });
  };

  return React.createElement("div", {
    className: c("navigator")
  }, React.createElement("button", {
    "aria-label": "Go back one page",
    className: c("button", "icon"),
    disabled: !backEnabled,
    onClick: handleBack,
    type: "button"
  }, React.createElement(BackwardIcon, null)), React.createElement("button", {
    "aria-label": "Go forward one page",
    className: c("button", "icon"),
    disabled: !forwardEnabled,
    onClick: handleForward,
    type: "button"
  }, React.createElement(ForwardIcon, null)), React.createElement("button", {
    "aria-label": "Refresh page",
    className: c("button", "icon"),
    onClick: handleRefresh,
    type: "button"
  }, React.createElement(RefreshIcon, null)), React.createElement("input", {
    "aria-label": "Current Sandpack URL",
    className: c("input"),
    name: "Current Sandpack URL",
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    type: "text",
    value: relativeUrl
  }));
};